"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdvertisingPurposeSubCategory = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
exports.AdvertisingPurposeSubCategory = (0, type_utils_1.makeEnum)({
    /** Fallback sub purpose */
    Advertising: 'ADVERTISING',
});
//# sourceMappingURL=advertising.js.map